<template>
    <div class="email-client-trigger">
        <a v-if="email" class="email-client-trigger__link" :href="getEmailHrefString" @click="clickedEmailLinkEvent">{{email}}</a>
        <Modal v-if="showConfirmModal" @modal:cancel="cancelEvent">
            <template #header-title>{{ $t('components.mailTo.header') }}</template>
            <template #body>
                <p>{{ $t('components.mailTo.body1') }}</p>
                <p>{{ $t('components.mailTo.body2') }}</p>
                <p>{{getEmailString}}</p>
            </template>
            <template #footer-other>
                <Button class="btn-primary" @click="copyToClipboardEvent">{{$t('labels.copyToClipboard')}}</Button>
                <Button class="btn-primary" @click="confirmEvent">{{$t('labels.yes')}}</Button>
            </template>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal.vue";
import Button from "primevue/button";

export default {
    components: {Button, Modal},
    props: {
        email: {
            required: true,
            type: String
        },

        name: {
            required: false,
            type: String,
            default: null
        }
    },

    data() {return {
        showConfirmModal: false
    };},

    methods: {
        clickedEmailLinkEvent(event) {
            event.preventDefault();
            this.showConfirmModal = true;
        },

        cancelEvent() {
            this.showConfirmModal = false;
        },

        confirmEvent() {
            window.location.href = this.getEmailHrefString;
            this.showConfirmModal = false;
        },

        copyToClipboardEvent() {
            navigator.clipboard.writeText(this.getEmailString).then(
                // Success
                () => {
                    // Do nothing particular
                },
                // Failure
                () => {
                    console.error('Unable to inject data into the clipboard.');
                }
            );

            // as known as "Finally"
            this.showConfirmModal = false;
        }
    },

    computed: {
        getEmailHrefString() {
            return 'mailto:' + this.getEmailString;
        },

        getEmailString() {
            return this.name ?
                `${this.name}<${this.email}>` :
                this.email;
        },
    }
}
</script>

<style lang="scss">
.email-client-trigger {
    &__link:is(a) {
        &:after {
            content: '\1F583'; // 🖃 - mail icon
            display: inline-block;
            margin-left: var(--margin-thin);
            font-weight: bold;
        }
    }

    &__target {
        margin-top: var(--margin-thick);
    }

    &__footer {
        &__controls {
            display: flex;
            gap: var(--gap);
        }
    }
}
</style>
